/* Loaded only on the dedicated Fall collection. */
(() => {
  if (window.jmtFallCelebrations) return;
  window.jmtFallCelebrations = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const drawings = {"leaves":"<path fill=\"#d9ac62\" d=\"M20 36C-2 22 5 8 33 3c4 22-1 31-13 33\"/><path stroke=\"#80532b\" stroke-width=\"2\" fill=\"none\" d=\"M9 37 28 10m-9 14-9-4m13-2 6 1\"/>","acorns":"<path fill=\"#d9ac62\" d=\"M9 18h22q0 16-11 20Q9 34 9 18\"/><path fill=\"#a5653b\" d=\"M7 19q0-13 13-13t13 13z\"/><path stroke=\"#a5653b\" stroke-width=\"3\" d=\"m20 7 3-6\"/><path stroke=\"#f2d59d\" d=\"m12 13 5 3m2-6 5 4m2-2 4 3\"/>","pumpkins":"<path stroke=\"#93b17b\" stroke-width=\"3\" fill=\"none\" d=\"M20 12q-3-7 3-9\"/><ellipse fill=\"#d98d48\" cx=\"20\" cy=\"24\" rx=\"17\" ry=\"13\"/><ellipse fill=\"none\" stroke=\"#9b562d\" stroke-width=\"1.4\" cx=\"20\" cy=\"24\" rx=\"9\" ry=\"13\"/><path stroke=\"#f2d59d\" d=\"M20 12v24\"/>","mushrooms":"<path fill=\"#f2d59d\" d=\"m16 18-3 18q7 4 14 0l-3-18\"/><path fill=\"#bd7045\" d=\"M3 22Q5 2 20 2t17 20z\"/><g fill=\"#f2d59d\"><circle cx=\"12\" cy=\"13\" r=\"3\"/><circle cx=\"24\" cy=\"8\" r=\"2.5\"/><circle cx=\"29\" cy=\"17\" r=\"3\"/></g>"};
  const kinds = Object.keys(drawings);
  let next = 0;
  const playing = new WeakSet();
  window.addEventListener('jmt:cart:changed', () => {
    if (reduced.matches) return;
    document.querySelectorAll('#MainContent [data-jmt-quickadd].jmt-quickadd--added').forEach(button => {
      if (playing.has(button)) return;
      playing.add(button);
      const kind = kinds[next++ % kinds.length];
      const stage = document.createElement('span');
      stage.className = 'jmt-fall-party jmt-fall-party--' + kind;
      stage.setAttribute('aria-hidden', 'true');
      stage.innerHTML = [0,1,2].map(i => '<span class="jmt-fall-dancer" style="--i:' + i + '"><svg viewBox="0 0 40 40" focusable="false">' + drawings[kind] + '</svg></span>').join('');
      button.dataset.jmtFallLast = kind;
      button.appendChild(stage);
      window.setTimeout(() => { stage.remove(); playing.delete(button); }, 1800);
    });
  });
})();
